import styled from "styled-components";

const LeftSession = styled.div`
  padding-right: 0.5rem !important;
  color: #fff;

  @media (max-width: 575px) {
    padding: 0 !important;f
  }
`;
export default LeftSession;
